// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__-p8gp","buttons":"RemoveExpirationActionButtons_buttons__1weEI"};